export default __webpack_public_path__ + "static/media/connect-network-resource.8ff685c7.svg";